module.exports = __webpack_public_path__ + "media/images/lb/906-fe2541ba976b714bd6eb9cdb85cf4f61.svg";